import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {finalize} from 'rxjs/operators';

import {UserBadge, UserProfile} from 'app/profile/model/model';
import {UserService} from 'app/profile/services/user.service';
import {getTranslation} from 'shared/helpers/get-translation';
import {NavService} from 'shared/nav/nav.service';
import {Badge} from '../../model/model';
import {BadgeService} from '../../services/badge.service';
import { DefaultPage } from 'app/menu/components/default-page/default-page';

const LABEL_FORMAT: string = 'dddd, DD.MM.YYYY';

@Component({
  selector: 'badge-page',
  templateUrl: 'badge-page.html',
  styleUrls: ['badge-page.scss'],
})
export class BadgePage extends DefaultPage {

  public badges: Array<Badge> =  [];

  public isLoading: boolean = false;
  private userBadges: Dictionary<UserBadge> = {};

  constructor(
    private navService: NavService,
    private translateService: TranslateService,
    private badgeService: BadgeService,
    private userService: UserService,
  ) {
    super(navService);
  }

  public get hasBadges(): boolean {
    return this.badges && this.badges.length > 0;
  }

  private ionViewWillEnter(): void {
    this.isLoading = true;
    this.badgeService.getBadges()
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe((entries) => { this.badges = entries; });
    this.userService.getUserProfile('full')
      .subscribe((profile: UserProfile) => {
        if (profile.badges) {
          this.userBadges = <Dictionary<UserBadge>> <any> profile.badges.reduce((map, obj: UserBadge) => {
            map[obj.badge] = obj;
            return map;
          }, {});
          this.userService.setNewBadgeCount(profile.badges.reduce((cnt, obj: UserBadge) => { return cnt + (obj.new ? 1 : 0); }, 0));
        }
      });
  }

  public getLocalizedDate(time: string): string {
    return moment(time).format(LABEL_FORMAT);
  }

  public getLocalizedBadgeText(text: Dictionary<string>): string {
    return getTranslation(text, this.translateService);
  }

  public getBadgeClass(badge: Badge): string {
    return this.userBadges[badge._id] ? '' : 'inactive';
  }

  public isNew(badge: Badge): boolean {
    return this.userBadges[badge._id] && this.userBadges[badge._id].new;
  }

  public showBadge(badge: Badge): void {
    this.navService.push('badge/detail', {badge: badge, userBadge: this.userBadges[badge._id]});
  }

}
